import { DateInput } from '@core/components/Inputs';
import { Grid } from '@material-ui/core';
import React from 'react';

const VendaPagamentoAVista = ({ id, name, onChange, onBlur, values, errors, touched, submitCount }) => {
  const _errors = {
    dataVencimento: (submitCount > 0 || touched?.dataVencimento) && errors?.dataVencimento,
  };

  return (
    <>
      <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
        <DateInput
          id={`${id}.dataVencimento`}
          name={`${name}.dataVencimento`}
          onChange={onChange}
          onBlur={onBlur}
          value={values?.dataVencimento || null}
          error={_errors?.dataVencimento}
          helperText={_errors?.dataVencimento}
          touched={!!_errors?.dataVencimento}
          required
          fullWidth
          variant="outlined"
          label="Data do vencimento"
        />
      </Grid>
    </>
  );
};

export default VendaPagamentoAVista;
